import React from 'react'
import Navbar from './layouts/Navbar';
import Footer from './layouts/Footer';
import { Outlet } from "react-router-dom";

function Landing() {

  

  return (
    <>

        <Navbar />
        <main>
          <Outlet />
        </main>
        
        <Footer />
    </>
  )
}

export default Landing